import React, { useEffect, useRef } from 'react';
import useEditorStore from "@/store/useEditorStore";

export const FlowPort = ({x,y,index,nodeId,dir=1}) => {
    const gRef = useRef(null);
    const updateNewLink = useEditorStore.use.updateNewLink();
    const setOpMode = useEditorStore.use.setOpMode();
    const outer = useEditorStore.use.outer();
    // var y = (d.h/2)-((numOutputs-1)/2)*13;
    // var x = d.w - 5;
    //setAttribute("transform","translate("+x+","+((y+13*portIndex)-5)+")")
    return (<g onMouseDown={(e)=>{
        e.preventDefault();
        e.stopPropagation();
        //记录按下的位置，鼠标位置和当前节点的位置
                //判断移动的数据
        // 获取SVG元素的屏幕转换矩阵
        const svg = outer;
        const matrix = svg.getScreenCTM();
        // 创建SVGPoint对象
        const pt = svg.createSVGPoint();
        // 设置鼠标的屏幕坐标
        pt.x = e.clientX;
        pt.y = e.clientY;
        // 转换鼠标坐标到SVG内部坐标
        const transformedPoint = pt.matrixTransform(matrix.inverse());
        setOpMode(1);
        updateNewLink(nodeId, transformedPoint.x,transformedPoint.y,index,transformedPoint.x+0.1,transformedPoint.y+0.1,dir);
    }}
    ref={gRef}
    className="red-ui-flow-port-input" transform={`translate(${x},${y})`}>
                <rect className="red-ui-flow-port" storke={"#999"} strokeWidth={1} fill={"#d9d9d9"} cursor={"move"} rx="3" ry="3" width="10" height="10">
                </rect>
            </g>);
}